module.exports = __webpack_public_path__ + "img/industrial_equip.89730298.svg";